const ChevronRight = () => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.3654 5.99991L0.732398 1.63991C0.378398 1.21591 0.436398 0.584908 0.860398 0.231909C1.2854 -0.122091 1.9154 -0.0640917 2.2684 0.359908L7.2684 6.35991C7.3074 6.40691 7.3274 6.46191 7.3564 6.51391C7.3804 6.55591 7.4094 6.59191 7.4274 6.63791C7.4724 6.75291 7.4994 6.87391 7.4994 6.99591C7.4994 7.12591 7.4724 7.24691 7.4274 7.36191C7.4094 7.40791 7.3804 7.44391 7.3564 7.48591C7.3274 7.53791 7.3074 7.59291 7.2684 7.63991L2.2684 13.6399C2.0704 13.8769 1.7864 13.9999 1.5004 13.9999C1.2744 13.9999 1.0474 13.9239 0.860397 13.7679C0.436397 13.4149 0.378397 12.7839 0.732397 12.3599L4.3654 7.99991L5.3654 6.99591" fill="currentColor" />
    </svg>
  );
};

export default ChevronRight;
